export enum EditMode {
  Default,
  ToggleStacks,
  EditTiles,
  PaintBlockers,
  EditBlockers,
  EditBlockerConnections,
  Remix,
  PaintUnderTileBlockers,
  EditUnderTileBlockers,
}
